<template>
  <div>
    <qc-table-client-pagination class="custom-upload" :list="list" :default-page-size="100" min-height="412px"
      max-height="412px" :empty-tips="$t('cos.empty_files')">

      <qc-table-column type="checkbox" :width="isMobile ? '20px' : '30px'" v-model="selectedList"></qc-table-column>

      <qc-table-column :label="$t('cos.name')" class="table-file" :width="isMobile ? '100px' : ''">
        <template slot-scope="{ item }">
          <div :title="item.remoteKey">
            <i class="cos-icon--32" :class="item.name | FileIcon(item.isDir)"></i>
            <span class="table-file__name text-overflow allow-user-select">{{item.name}}</span>
          </div>
        </template>
      </qc-table-column>

      <qc-table-column :label="$t('cos.size')" field="size" :width="isMobile ? '55px' : '180px'">
        <template slot-scope="{ item }">
          <div>
            {{item.size | formatSize}}
          </div>
        </template>
      </qc-table-column>

      <qc-table-column :label="$t('cos.status')" :width="isMobile ? '125px' : '200px'">
        <template slot-scope="{ item }">
          <div v-if="item.state === 'waiting'">
            <div class="tc-15-progress">
              <div class="tc-15-progress-value" aria-valuemax="100" aria-valuemin="0" aria-valuenow="0`"
                style="width:0">
                <span class="text-label">{{stateMap.waiting}}</span>
              </div>
            </div>
          </div>

          <div v-else-if="item.state==='checking'">
            <div class="tc-15-progress">
              <div class="tc-15-progress-value" aria-valuemax="100" aria-valuemin="0" aria-valuenow="0`"
                style="width:0">
                <span class="text-label">{{stateMap.checking}}
                  {{(parseInt(item.hashPercent * 100)+'%')}}</span>
              </div>
            </div>
          </div>

          <div v-else-if="item.state==='uploading'">
            <div class="tc-15-progress">
              <div class="tc-15-progress-value" aria-valuemax="100" aria-valuemin="0"
                :aria-valuenow="`${item.percent*100}%`" :style="{width:`${item.percent*100}%`}">
                <span class="text-primary">{{item.uploadSpeed | formatSize}}/s</span>
                <span class="schedule" v-if="item.needTime">{{$t('cos.remaining')}} {{item.needTime}}</span>
              </div>
            </div>
          </div>

          <div v-else-if="item.state==='success'">
            <p class="text-label">{{stateMap.success}}</p>
          </div>

          <div v-else-if="item.state==='paused'">
            <i class="n-error-icon"></i>
            <span class="text-danger">{{stateMap.paused}}</span>
          </div>

          <div v-else-if="item.state==='error'">
            <i class="n-error-icon"></i>
            <span class="text-danger state-error allow-user-select">
              {{item.error || stateMap.fail}}
            </span>
          </div>

        </template>
      </qc-table-column>
      <qc-table-column :label="$t('cos.operation')" :width="isMobile ? '50px' : '140px'">
        <template slot-scope="{ item }">
          <div class="tc-g cos-table-operate">
            <div class="tc-g-u-1-3"
              v-if="item.state==='waiting' || item.state==='checking' || item.state==='uploading'">
              <div class="cos-icon--16 pause" :title="$t('cos.pause')" @click.stop="doTaskAction('pauseTask', item)">
              </div>
            </div>
            <div class="tc-g-u-1-3" v-else-if="item.state==='paused'">
              <div class="cos-icon--16 start" :title="$t('cos.start')" @click.stop="doTaskAction('restartTask', item)">
              </div>
            </div>
            <div class="tc-g-u-1-3" v-else-if="item.state==='error'">
              <div class="cos-icon--16 retry" :title="$t('cos.retry')" @click.stop="doTaskAction('restartTask', item)">
              </div>
            </div>
            <!-- <div class="tc-g-u-1-3" v-else-if="item.state==='success'">
              <div class="cos-icon--16 search" title="显示文件" @click="showInRemoteFolder(item)">
              </div>
            </div> -->
            <!-- <div class="tc-g-u-1-3">
              <div class="cos-icon--16 finder" title="$t('cos.show_in_local_folder')" @click="showInLocalFolder(item)">
              </div>
            </div> -->
            <div class="tc-g-u-1-3">
              <div class="cos-icon--16" :class="{'cancel': ['waiting','checking','uploading'].includes(item.state),
                'delete':['error','success','paused'].includes(item.state)}" :title="$t('cos.cancel')"
                @click.stop="doTaskAction('cancelTask', item)">
              </div>
            </div>
          </div>
        </template>
      </qc-table-column>

      <template slot="pagination" slot-scope="page">
        <qc-pagination :total-num="page.totalNum" :page-size.sync="page.pageSize" :curr-page.sync="page.currPage"
          :min-page-size="100" :max-page-size="500" :page-size-step="100" has-check-box
          :selectedNum="selectedList.length">
        </qc-pagination>
      </template>
    </qc-table-client-pagination>
  </div>
</template>

<script>
import eventProxy from 'tools/eventProxy';
import { tips, formatSecond } from 'tools/utils';
import device from 'current-device';
import dialog from 'tools/dialog';
import { cos } from 'helper/cos/index';

export default {
  props: {
    disableBtn: {
      type: Object,
      required: true,
    },
    filter: {
      type: Object,
      required: true,
    },
  },
  data() {
    const stateMap = {
      waiting: this.$t('cos.waiting_upload'),
      checking: this.$t('cos.file_checking'),
      success: this.$t('cos.upload_success'),
      fail: this.$t('cos.upload_failed'),
      paused: this.$t('cos.upload_paused'),
    };

    return {
      stateMap,
      list: [],
      selectedList: [],
      selectMap: {},
      deleteAllShow: true,
    };
  },
  watch: {
    list() {
      this.selectedList = this.list.filter(item => item.checked);
      // this.renderTableClass(this.list);
      this.updateButtonStatus();
    },
    selectedList() {
      this.updateButtonStatus();
    },
    filter(val, old) {
      if (
        val.showDoing !== old.showDoing
        || val.showError !== old.showError
        || val.showFinish !== old.showFinish
      ) {
        this.updateList();
      }
    },
  },
  mounted() {
    this.updateList();
    eventProxy.on('upload-list-update', this.updateList);
  },
  computed: {
    isMobile() {
      return device.mobile();
    },
  },
  methods: {
    formatSecond,
    // 渲染表格：根据是否有滚动条设置表头不同的样式
    // renderTableClass(list) {
    //   console.log('renderTableClass -> list', list);
    // },
    updateList(data) {
      const taskList = (data && data.list) || cos.getTaskList();
      let list = taskList.filter(item => item.state !== 'canceled');
      list = list.reverse().map(this.formatTask);

      // 对显示的列表标记选中
      const selectMap = {};
      this.selectedList.forEach(item => {
        selectMap[item.id] = 1;
      });
      list.forEach(item => {
        if (selectMap[item.id]) item.checked = true;
      });

      // 过滤状态
      const stateCheckAll = this.filter.showDoing
        && this.filter.showError
        && this.filter.showFinish;
      if (!stateCheckAll) {
        list = list.filter(
          v => (['waiting', 'checking', 'uploading', 'paused'].includes(v.state)
              && this.filter.showDoing)
            || (v.state === 'error' && this.filter.showError)
            || (v.state === 'success' && this.filter.showFinish),
        );
      }
      this.list = list;
    },
    formatTask(item) {
      const isDir = item.Key.slice(-1) === '/';
      let name = item.Key.replace(/\/$/, '').replace(/^.*\//, '');
      if (isDir) {
        name += '/';
      }
      let { error } = item;
      if (error) {
        error = error.Code || error.Message;
        // error = lang.err(`error['${error.Code}']`, error) || error.Message;
      }
      return {
        key: item.id, // vue :key
        id: item.id,
        remoteKey: item.Key,
        Bucket: item.Bucket,
        Region: item.Region,
        FilePath: item.FilePath,
        name,
        state: item.state,
        error,
        size: item.size || 0,
        uploadSpeed: item.speed,
        percent: item.percent,
        hashPercent: item.hashPercent,
        needTime: item.speed
          ? formatSecond((item.size - item.loaded) / item.speed)
          : '',
      };
    },
    doTaskAction(action, item) {
      const list = item ? [item] : this.selectedList;
      if (!list.length) return;
      list.forEach(({ id }) => cos[action](id, true));
    },
    pauseAllTask() {
      this.list.forEach(item => {
        if (['waiting', 'checking', 'uploading'].includes(item.state)) {
          cos.pauseTask(item.id);
        }
      });
    },
    restartAllTask() {
      this.list.forEach(item => {
        if (['paused', 'error'].includes(item.state)) {
          cos.restartTask(item.id);
        }
      });
    },
    removeAllTask() {
      dialog.confirm(
        { message: this.$t('cos.delete_all_task_confirm') },
        confirm => {
          if (confirm) {
            this.list.forEach(item => {
              cos.cancelTask(item.id);
            });
          }
        },
      );
    },
    removeFinishTask() {
      this.list.forEach(item => {
        const useless = ['canceled', 'success'].includes(item.state);
        if (useless) {
          cos.cancelTask(item.id);
        }
      });
    },
    updateButtonStatus() {
      this.$emit('update:disableBtn', {
        select: this.selectedList.length === 0,
        all: this.list.length === 0,
      });
    },
    showInRemoteFolder(item) {
      cos.headObject(
        {
          Bucket: item.Bucket,
          Region: item.Region,
          Key: item.remoteKey,
        },
        (err, data) => {
          if (data && data.statusCode === 200) {
            this.$emit('close');
            setTimeout(() => {
              const isDir = item.remoteKey.slice(-1) === '/';
              const Prefix = isDir
                ? item.remoteKey.replace(/[^/]+\/$/, '')
                : item.remoteKey.replace(/[^/]+$/, '');
              eventProxy.emit('bucket-switch', {
                Bucket: item.Bucket,
                Region: item.Region,
                Prefix,
                Key: item.remoteKey,
              });
            });
          } else {
            tips.error('remote_file_not_exist');
          }
        },
      );
    },
  },
};
</script>

<style lang="scss" scoped>
$xs: 360px;
$sm: 600px;
::v-deep .custom-upload {
  @media screen and (max-width: $sm) {
    .tc-15-table-panel {
      .tc-15-table-box {
        td:first-child, th:first-child {
          padding-left: 5px;
        }
        td, th {
          padding-left: 0;
          padding-right: 3px;
          .cos-icon--32 {
            width: 14px;
            height: 14px;
          }
          .table-file__name {
            margin-left: 0;
          }
          .cos-table-operate {
            .tc-g-u-1-3 {
              padding-left: 6px;
              padding-right: 6px;
              .cos-icon--16 {
                width: 12px;
                height: 12px;
              }
            }
          }
        }
      }
    }
    .tc-15-page {
      padding: 10px 0 14px;
      .tc-15-page-text {
        margin-right: 0;
      }
    }
  }
}
</style>
